var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9677 1.67285H3.03229C2.28095 1.67285 1.67188 2.28193 1.67188 3.03327V24.9687C1.67188 25.72 2.28095 26.3291 3.03229 26.3291H24.9677C25.719 26.3291 26.3281 25.72 26.3281 24.9687V3.03327C26.3281 2.28193 25.719 1.67285 24.9677 1.67285Z",
    fill: "#3D5A98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6792 26.3269V16.7789H21.8833L22.3625 13.0581H18.6792V10.6831C18.6792 9.60603 18.9792 8.87061 20.5229 8.87061H22.4938V5.53728C21.5394 5.438 20.5803 5.3907 19.6208 5.39561C16.7833 5.39561 14.8292 7.12478 14.8292 10.3144V13.0581H11.625V16.7789H14.8292V26.3269H18.6792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.95238d911f48584243b8b76e5de28704.svg";
export { ForwardRef as ReactComponent };